var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import { Url } from '@ef-carbon/primitive';
import assign from './assign';
import nodeFactory, { register } from './factory';
import Type from './Type';
export class Generic {
    constructor(_a) {
        var {url, node, copy} = _a, rest = __rest(_a, [
                'url',
                'node',
                'copy'
            ]);
        this.type = Type.Link;
        this.url = new Url(url);
        this.node = nodeFactory(node, copy);
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.configurable = false;
        descriptors.type.writable = false;
        descriptors.url.configurable = false;
        descriptors.node.configurable = false;
        Object.defineProperties(this, descriptors);
        assign(this, copy, Object.assign({}, rest));
    }
}
export class Link extends Generic {
}
export const klass = Link;
export default Link;
register(Type.Link, Link);    //# sourceMappingURL=Link.js.map
